import { NumberInput } from '@/app/components'
import { Text } from '@/components'
import { Flame, Snowflake } from 'lucide-react'

type Props = {
  variant: 'heat' | 'cool'
  title: string
  initialValue: number
  range: [number, number]
  onChange: (value: number) => void
  showPlusSign?: boolean
  helperText?: string
}

/**
 * A single grid-support setpoint control: a heat/cool labelled row with the
 * reused NumberInput stepper on the right and optional helper text beneath it.
 * Rows stack vertically so the control fits a phone-width column.
 */
export default function EventSetpointStepper({
  variant,
  title,
  initialValue,
  range,
  onChange,
  showPlusSign,
  helperText,
}: Props) {
  const Icon = variant === 'heat' ? Flame : Snowflake
  const colorClass =
    variant === 'heat' ? 'text-base-red-500' : 'text-base-blue-500'

  return (
    <div className="flex items-start justify-between gap-4">
      {/* min-height matches the stepper so the label centers on it, ignoring
          any helper text that sits below the stepper */}
      <div className="flex min-h-[40px] flex-row items-center gap-2">
        <Icon size={18} className={`flex-none ${colorClass}`} />
        <Text variant="body1">{title}</Text>
      </div>
      <div className="flex flex-col items-center justify-center">
        <NumberInput
          initialValue={initialValue}
          range={range}
          onChange={onChange}
          showPlusSign={showPlusSign}
          suffix="°"
          disableAtBounds
        />
        {helperText && (
          <div className="mt-2 text-xs text-themed-grey-500">{helperText}</div>
        )}
      </div>
    </div>
  )
}
